export const PRIVACY_POLICY = 'https://chatbeat.com/privacy-policy';
export const TERMS_OF_USE = 'https://chatbeat.com/terms-of-use';
export const TAG_NAME = 'chatbeat_tag_name_';

/**
 * Returns the href to use when opening a source URL as a link.
 * Rewrites `google.com/viewer/place?mid=...` → `www.google.com/viewer/place?mid=...`
 * so that Google viewer URLs open correctly. Only this exact path+query shape on
 * bare `google.com` is rewritten — any other google.com URL and all subdomains are
 * left untouched. Returns the input unchanged on parse failure.
 */
export const encodeSourceHash = (sourceUrl: string): string => btoa(encodeURIComponent(sourceUrl));

export const decodeSourceHash = (hash: string): string => {
  try {
    return decodeURIComponent(atob(hash));
  } catch {
    return '';
  }
};

export const getSourceHref = (url: string): string => {
  try {
    const parsed = new URL(url);
    if (
      parsed.hostname === 'google.com' &&
      parsed.pathname === '/viewer/place' &&
      parsed.searchParams.has('mid')
    ) {
      parsed.hostname = 'www.google.com';
    }
    return parsed.toString();
  } catch {
    return url;
  }
};